import React from 'react';
import confetti from 'canvas-confetti';
import { motion, useReducedMotion } from 'framer-motion';
import Connections from './Connections';
import { fadeUp, Parallax, Reveal, StaggerContainer, StaggerItem } from './motion/Reveal';

const Contact: React.FC = () => {
  const reducedMotion = useReducedMotion();

  const celebrate = (e: React.MouseEvent) => {
    if (reducedMotion) return;
    confetti({
      particleCount: 120,
      spread: 70,
      origin: { x: e.clientX / window.innerWidth, y: e.clientY / window.innerHeight },
    });
  };

  return (
    <section id="contact" className="bg-grey-50 py-16 px-6 md:px-12 text-left">
      <div className="container mx-auto max-w-3xl">
        <Reveal>
          <Parallax>
            <h2 className="text-4xl font-extrabold mb-6 bg-gradient-to-r from-black via-primary to-black bg-[length:200%_auto] bg-clip-text text-transparent motion-safe:animate-shimmer">
              Let’s Build Something Great Together
            </h2>
          </Parallax>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-lg text-grey-20 mb-8">
            If you're looking for a skilled software engineer with a passion for data, backend development, and system optimization, let’s connect! I’m always excited about new challenges and opportunities to innovate.
          </p>
        </Reveal>

        <StaggerContainer className="flex flex-col items-start gap-6" stagger={0.15}>
          <motion.div variants={fadeUp}>
            <motion.a
              href="https://docs.google.com/document/d/1V5bTGFC6-JdxDq9A9OhnOPZQsnkyxArkwb98gC6u1Nc/export?format=pdf&tab=t.0"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.97 }}
              onClick={celebrate}
              className="group relative inline-block overflow-hidden bg-primary text-white font-bold py-3 px-5 rounded-md"
            >
              Download Resume
              {/* White streak sweeps across on hover */}
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-white/30 opacity-0 group-hover:opacity-100 group-hover:animate-shine"
              ></span>
            </motion.a>
          </motion.div>

          <StaggerItem>
            <p className="font-body text-lg font-semibold uppercase text-grey-20">
              Connect with me
            </p>
            <div className="flex items-center justify-start pt-5 pl-2 sm:justify-start sm:pt-0 text-primary">
              <Connections />
            </div>
          </StaggerItem>
        </StaggerContainer>
      </div>
    </section>
  );
};

export default Contact;
